import { createContext, useContext, useState } from "react";
import { AuthService } from "../services";
import { useDispatch } from "react-redux";
import { logout } from "../stores/authSlice";

const GlobalContext = createContext({
    customerValue: '1',
    setCustomerValue: (value: string) => { },
    feedbackValue: '1',
    setFeedbackValue: (value: string) => { },
    handleLogout: () => { },
});

export const GlobalContextProvider = ({ children }: any) => {
    const [customerValue, setCustomerValue] = useState('1');
    const [feedbackValue, setFeedbackValue] = useState('1');
    const dispatch = useDispatch();
    const handleLogout = () => {
        AuthService.logout({ token: localStorage.getItem('fcmToken') })
        dispatch(logout());
        window.location.href = '/login';
    };
    return (
        <GlobalContext.Provider value={{
            customerValue,
            setCustomerValue,
            feedbackValue,
            setFeedbackValue,
            handleLogout
        }}>
            {children}
        </GlobalContext.Provider>
    )
};

export const useGlobalContext = () => useContext(GlobalContext);
